import { Method, RawAxiosRequestHeaders } from "axios";

import { axiosInstance } from "../model";

export const handleFetch = async <R, T>(
  url: string,
  method: Method,
  data?: T,
  headers?: RawAxiosRequestHeaders,
): Promise<R> => {
  try {
    const response = await axiosInstance({
      method,
      url,
      data: data || {},
      headers: headers || { "Content-Type": "application/json" },
    });
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    if (error?.response?.data?.error) {
      return error?.response?.data;
    }

    throw new Error(error);
  }
};
